<template lang="pug">
div
	div.weathermap
		area-map.maplogo(v-if="area" :hour="hour" :type="type" :area="area")
		region-map.maplogo(v-if="!area" :hour="hour" :type="type" :show-pressure="showPressure" :weatherregion="region")
			//- .static-map-holder(:class="region" :style="mapStyle")
				template(v-for="item in overlays")
					img#forecast-overlay(:src="item.url" :style="overlayStyle" :class="item.type" alt="Weerkaart" ref="overlay")
				.country-overlay(v-if="!hideBorders" :class="region")

			.suggest(v-if="suggestDestination" :style="suggestDestination.style")
				a(:href="suggestDestination.url")
					.suggest-dot
				.favorite-name {{ suggestDestination.name }}
		v-container.timeIndicator.pb-1
			v-row(align="center" dense)
				v-col.shrink
					v-sheet.caption.d-inline-block.accent--text.text-no-wrap.px-2(color="info")
						ws-icon(small) clock-o
						| {{ timeindicator }}
				v-col.shrink.hidden-sm-and-down( v-if="type != 'sun' && !area")
					v-btn.elevation-0.accent--text.my-0(@click="showAnimator = true" small color="info" )
						ws-icon.mr-2(small) download
						| download
				v-spacer
				v-col.shrink.pressureCheckbox(v-if="canShowPressure")
					v-btn.accent--text(@click="showPressure = !showPressure" small color="info" elevation="0")
						v-icon.mr-2(small) {{showPressure ? 'check_box' : 'check_box_outline_blank'}}
						| luchtdruk
		.destinationSearch.hidden-sm-and-down(v-if="!hideSearch")
			searchbar.ma-3(@select="selectDestination" background="#fff")
	weather-legend(v-if="currentType.legend" :type="currentType.legend")
	scrubber(:period="currentType.period" :rundate="rundate" :value.sync="hour" :step="currentType.step" :cumulative="currentType.cumulative" preload="false" @input="setHour" @scrubStart="triggerPreload")
	animator(v-model="showAnimator" :region="region" :type="currentType.forecastType" :pressure="showPressure" :period="currentType.period")

</template>

<style lang="scss" scoped>
.weathermap {
	position: relative;
}

.destinationSearch {
	width: 300px;
	position: absolute;
	top: 0;
	left: 0;

	.v-input__control {
		min-height: 0 !important;
		background-color: white !important;
		font-size: 80%;
	}
}

.timeIndicator {
	position: absolute;
	bottom: 0;
	left: 0;
	display: block;
	width: auto;

	.v-icon {
		color: inherit;
	}

	.v-sheet {
		height: 28px;
		line-height: 28px;
	}
}

.maplogo {
	&:after {
		position: absolute;
		right: $spacer;
		top: $spacer;
		width: 140px;
		height: 30px;
		padding-top: 24px;
		background-size: fit;
		background-image: url('/images/logo.svg');
		background-repeat: no-repeat;
		content: '';

		@media #{map-get($display-breakpoints, 'xs-only')} {
			display: none;
		}
	}
}

.resort-dot {
	position: absolute;
	border: 2px solid white;
	background: #2f619b;
	width: 10px;
	height: 10px;
	margin-left: -5px;
	margin-top: -5px;
	border-radius: 50%;
	display: none;
}

.favorite {
	position: absolute;
	display: none;

	.favorite-name {
		display: none;
		position: absolute;
		color: white;
		text-shadow: 1px 1px 0 rgba(0, 0, 0, 0.5);
		background-color: rgba(48, 97, 155, 0.8);
		white-space: nowrap;
		font-size: 12px;
		padding: 0.1rem $spacer / 2;
		top: -11px;
		left: 10px;
	}

	&:hover .favorite-name {
		display: block;
	}
}

.favorite-dot {
	border: 2px solid white;
	background: #ff6600;
	width: 10px;
	height: 10px;
	margin-left: -5px;
	margin-top: -5px;
	border-radius: 50%;
	content: '';
}

.suggest {
	position: absolute;
	display: none;

	.favorite-name {
		display: none;
		position: absolute;
		color: white;
		text-shadow: 1px 1px 0 rgba(0, 0, 0, 0.5);
		background-color: rgba(48, 97, 155, 0.8);
		white-space: nowrap;
		font-size: 12px;
		padding: 0.1rem $spacer / 2;
		top: -11px;
		left: 10px;
	}

	&:hover .favorite-name {
		display: block;
	}
}

.suggest-dot {
	border: 2px solid white;
	background: blue;
	width: 10px;
	height: 10px;
	margin-left: -5px;
	margin-top: -5px;
	border-radius: 50%;
	content: '';
}
</style>

<script>
import Searchbar from '@/components/searchbar.vue';
import WeatherLegend from '../legends/index.vue';
import Scrubber from '../scrubber.vue';
import Animator from '../animator.vue';
import AreaMap from './areamap.vue';
import RegionMap from './regionmap.vue';

import { weathermapTypes, regionBounds, lngLatToPixels } from './utils.js';

export default {
	components: {
		WeatherLegend,
		Scrubber,
		Animator,
		Searchbar,
		AreaMap,
		RegionMap
	},
	props: {
		region: {
			type: String,
			default: 'alps'
		},
		type: {
			type: String,
			default: 'snow'
		},
		rundate: {
			type: String,
			default: 'snow'
		},
		hideBorders: {
			type: Boolean,
			default: false
		},
		hideSearch: {
			type: Boolean,
			default: false
		},
		area: {
			type: String,
			default: null
		}
	},
	data() {
		return {
			hour: 24,
			types: weathermapTypes,
			showPressure: false,
			showAnimator: false,

			regionBounds,
			suggestion: false
		};
	},

	computed: {
		overlays() {
			const overlays = [
				{ url: this.overlayforType(this.type), type: this.type }
			];
			if (this.showPressure && this.canShowPressure) {
				overlays.push({
					url: this.overlayforType('pressure'),
					type: 'pressure'
				});
			}
			return overlays;
		},

		overlayStyle() {
			if (this.customBounds) {
				return this.regionOffset(
					this.dimensions.containerheight,
					this.dimensions.containerwidth,
					this.customBounds,
					this.region
				);
			}
			return {};
		},

		canShowPressure() {
			return (
				this.region === 'europe' &&
				['snowradar', 'clouds', 'wind'].includes(this.type)
			);
		},

		currentType() {
			return this.types[this.type] || this.types.snowforecast;
		},

		timeindicator() {
			const enddate = this.$dayjs(this.$store.state.rundate)
				.startOf('day')
				.add(this.hour, 'hours');
			let startdate = this.$dayjs().startOf('day');
			if (this.currentType.period > 0) {
				startdate = this.$dayjs(this.$store.state.rundate)
					.startOf('day')
					.add(this.hour, 'hours')
					.subtract(this.currentType.period, 'hours');
			}

			return this.currentType.timeindicator
				.replace(/%s/, startdate.format('dddd HH:mm'))
				.replace(/%e/, enddate.format('dddd HH:mm'));
		},

		suggestDestination() {
			if (this.suggestion) {
				const contentWidth = this.$store.state.content_width.full_unpadded;
				const favpx = lngLatToPixels(
					parseFloat(this.suggestion.geography.location.coordinates[0]),
					parseFloat(this.suggestion.geography.location.coordinates[1]),
					contentWidth / (this.region === 'alps' ? 1.6 : 1.25),
					contentWidth,
					this.region
				);

				const style = {
					display: 'block',
					left: favpx.left + 'px',
					top: favpx.top + 'px'
				};

				let url = this.localePath({
					name: 'areas-area-forecast',
					params: { area: this.suggestion.slug }
				});

				if (this.suggestion.__typename === 'Resort') {
					url = this.localePath({
						name: 'resorts-resort-forecast',
						params: { resort: this.suggestion.slug }
					});
				}

				return {
					url,
					name: this.suggestion.name,
					style
				};
			}
			return false;
		}
	},
	watch: {
		'$route.hash'() {
			this.readHourHash();
		},
		currentType() {
			this.setClosestHour();
			this.preloadType(this.type);
		},

		showPressure(show) {
			if (show) {
				this.preloadType('pressure');
			}
		}
	},
	mounted() {
		this.hour = this.types[this.type].starthour;
		this.readHourHash();
		// setTimeout(this.calcSize, 300);
	},
	methods: {
		setHour(hour) {
			this.hour = hour;
		},

		triggerPreload() {
			this.preloadType(this.type);
		},

		preloadType(type) {
			const typeobj = this.types[type];

			if (typeobj.preloaded !== true) {
				for (let i = 0; i <= 144 - typeobj.period; i = i + typeobj.step) {
					const preloadImage = new Image();
					const image = typeobj.imagetpl
						.replace(/%s/, i)
						.replace(/%e/, i + typeobj.period);
					preloadImage.src = `https://maps.wintersport.nl/${this.rundate}/${this.region}/${typeobj.forecastType}/${image}.png`;
				}
				typeobj.preloaded = true;
			}
		},

		setClosestHour() {
			if (this.hour % this.currentType.step !== 0) {
				this.hour =
					Math.ceil(this.hour / this.currentType.step) * this.currentType.step;
			}
			if (this.hour < this.currentType.period) {
				this.hour = this.currentType.period;
			}
		},

		selectDestination(destination) {
			if (destination) {
				this.suggestion = destination;
				const contentWidth = this.$store.state.content_width.full_unpadded;
				const favpx = lngLatToPixels(
					parseFloat(this.suggestion.geography.location.coordinates[0]),
					parseFloat(this.suggestion.geography.location.coordinates[1]),
					contentWidth / (this.region === 'alps' ? 1.6 : 1.25),
					contentWidth,
					this.region
				);

				if (
					favpx.left < 0 ||
					favpx.left > this.$store.state.content_width.full ||
					favpx.top < 0
				) {
					if (destination.__typename === 'Area') {
						this.$router.push(
							this.localePath({
								name: 'areas-area-forecast',
								params: { area: destination.slug }
							})
						);
					}
					if (destination.__typename === 'Resort') {
						this.$router.push(
							this.localePath({
								name: 'resorts-resort-forecast',
								params: { resort: destination.slug }
							})
						);
					}
				} else {
					this.suggestion = destination;
				}
			} else {
				this.suggestion = null;
			}
		},

		readHourHash() {
			if (window.location.hash) {
				for (const prop of window.location.hash.split('#')[1].split('-')) {
					if (isNaN(prop)) {
						// this.type = prop;
					} else {
						this.hour = parseInt(prop);
					}
				}

				this.$el.scrollIntoView({ block: 'center' });
			}
		}
	}
};
</script>
